import { Injectable } from '@angular/core';
import Swal from "sweetalert2";
const Toast = Swal.mixin({
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 6000,
  width:500,
  timerProgressBar: true,
  background: "#e8e8e8",
  backdrop:false,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})
@Injectable({
  providedIn: 'root'
})
export class AlertServiceService {

  constructor() { }
  activarAlert(mensaje:any,icon){
    Toast.fire({
      icon: icon,
      title: mensaje
    })
  }
  cerrarAlert(){
    if (Toast)
    Toast.close();
  }
}
